/**
 * The "Posted 9.22.26" line on a class Music & Video shelf card (bug B34).
 *
 * THE DAY IS THE STUDIO'S. Bobbie, 2026-09-23, verbatim: "I'm my the wrong
 * date, just posted it is 9:25pm CSt 9/22". Every time shown at this studio
 * is studio time, America/Chicago (CLAUDE.md). 9:25pm Central is already the
 * next day in UTC, so a formatter that asks the device's own zone prints the
 * wrong day on any phone or laptop not set to Central. The day is asked of
 * the zone by name through studioDayKey, the Hub's one answer to "what day is
 * it at the studio", which itself falls back to the device's day rather than
 * throwing on a runtime with no time zone data.
 *
 * The number is the server's. addedAt is stamped by the server lane
 * (offeringWrite.mjs, classMediaCommit.mjs) from its own clock, never the
 * uploading phone's, so this only has to print it in the right zone.
 *
 * The format is unchanged, "Posted M.D.YY", and an unknown date (0, missing,
 * not a number) prints nothing, never 1970.
 *
 * Imports only studioDay.ts, with the explicit .ts extension, so
 * tests/media-shelf-date-and-label.test.mjs runs it directly under Node.
 */
import { studioDayKey } from './studioDay.ts';

export function mediaPostedLabel(addedAt: number | undefined): string {
  if (!addedAt || !Number.isFinite(addedAt)) return '';
  const [year, month, day] = studioDayKey(addedAt).split('-');
  if (!year || !month || !day) return '';
  return `Posted ${Number(month)}.${Number(day)}.${year.slice(-2)}`;
}
